module.exports = __webpack_public_path__ + "static/media/(V)-Artesanato-22.cfa07bfe.jpg";